module.exports = __webpack_public_path__ + "static/img/bj@2x.d51b65d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bj@2x.png
// module id = +Z75
// module chunks = 1